<template>
  <MainSoftForm>
    <template v-slot:body>
      <MyFormGenerator :validator="$v" :schema="schema" />
    </template>
    <template v-slot:action>
      <v-row>
        <v-col cols="12">
          <v-btn
            color="success"
            :loading="is_loading"
            :disabled="is_loading || $v.$error"
            @click="submit"
            block
            >{{ $_t("attribute.send") }}</v-btn
          >
        </v-col>
      </v-row>
    </template>
  </MainSoftForm>
</template>

<script>
import MainSoftForm from "@/components/app/form/MainSoftForm";
import MyFormGenerator from "@/components/app/form/MyFormGenerator";
import { PAY_FORM_SCHEMA } from "@/packages/dashboard/schema/PAYMENT_SCHEMA";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "PayForm",
  components: { MyFormGenerator, MainSoftForm },
  data: () => ({
    form: PAY_FORM_SCHEMA.model,
    schema: PAY_FORM_SCHEMA.schema,
  }),
  validations: {
    ...PAY_FORM_SCHEMA.validations,
  },
  computed: {
    ...mapGetters({
      cert: "dashboard/get_cert",
      is_loading: "loading/is_loading",
    }),
  },
  methods: {
    ...mapActions({
      closeDialog: "dialog/closeDialog",
    }),
    async submit() {
      try {
        if (!this.isFormValidate()) return;
        const paymentPhoto = new FormData();
        paymentPhoto.append("file", this.form.payId);
        const paymentPhotoId = await this.$actions.uploadImage(
          paymentPhoto,
          "payment"
        );
        const payload = {
          certificateId: this.cert.certificateId,
          payId: paymentPhotoId.data,
        };
        await this.$actions.addPayToCert(payload);
        this.form.payId = null;
        this.$v.$reset();
        this.closeDialog();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped></style>
